<script>
  import { getContext, onMount } from 'svelte'
  import { SELECTED_COLOR_KEY } from './ChromaPicker.svelte'

  const selectedColor = getContext(SELECTED_COLOR_KEY)

  let hueCanvas
  let hueCtx
  let hueMarker

  let localSelected

  const CANVAS_HEIGHT = 300
  const CANVAS_WIDTH = 300
  const MARKER_SQUARE = 20

  const handleHueClick = event => {
    const canvasDimensions = hueCanvas.getBoundingClientRect()

    const x = event.clientX - canvasDimensions.left
    const y = event.clientY - canvasDimensions.top

    const pixel = hueCtx.getImageData(x, y, 1, 1)['data'] // Read pixel Color
    const rgb = `rgb(${pixel[0]},${pixel[1]},${pixel[2]})`
    localSelected = rgb
    selectedColor.change({ rgb }, $selectedColor)

    hueMarker.style.top = `${y}px`
    hueMarker.style.left = `${x}px`
    hueMarker.style.backgroundColor = rgb
  }

  const createHueCanvas = () => {
    hueCtx = hueCanvas.getContext('2d') // This create a 2D context for the canvas

    let gradientH = hueCtx.createLinearGradient(0, 0, hueCtx.canvas.width, 0)
    gradientH.addColorStop(0, '#fff')
    gradientH.addColorStop(1, $selectedColor.rgb)
    hueCtx.fillStyle = gradientH
    hueCtx.fillRect(0, 0, hueCtx.canvas.width, hueCtx.canvas.height)

    let gradientV = hueCtx.createLinearGradient(0, 0, 0, 300)
    gradientV.addColorStop(0, 'rgba(0,0,0,0)')
    gradientV.addColorStop(1, '#000')
    hueCtx.fillStyle = gradientV
    hueCtx.fillRect(0, 0, hueCtx.canvas.width, hueCtx.canvas.height)
  }

  const resetMarker = () => {
    hueMarker.style.top = `0px`
    hueMarker.style.left = `${CANVAS_WIDTH - MARKER_SQUARE}px`
    hueMarker.style.backgroundColor = $selectedColor.rgb
  }

  $: if ($selectedColor && hueCanvas && $selectedColor.rgb !== localSelected) {
    createHueCanvas()
    resetMarker()
  }

  onMount(() => {
    createHueCanvas()
  })
</script>

<div class="hue" style="--canvas-height: {CANVAS_HEIGHT}px">
  <canvas
    width="{CANVAS_WIDTH}px"
    height="{CANVAS_HEIGHT}px"
    id="hue_canvas"
    class="canvas"
    bind:this={hueCanvas}
    on:click={e => handleHueClick(e)}
  />
  <div id="hue_marker" class="marker" bind:this={hueMarker} />
</div>

<style>
  .hue {
    height: var(--canvas-height);
  }
</style>
